import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NzSliderModule, NzTabsModule } from 'ng-zorro-antd';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { EppColorPickerComponent } from './epp-color-picker.component';


@NgModule({
  declarations: [EppColorPickerComponent],
  imports: [
    CommonModule,
    NzDropDownModule,
    NzTabsModule,
    NzSliderModule,
    FormsModule,
    TranslateModule,
  ],
  exports: [
    EppColorPickerComponent
  ]
})
export class EppColorPickerModule { }
